export interface PopularArticle {
  '@path': string;
  articleTitle: string;
}
